<template>
  <div>
    <b-table
      :items="submitals"
      :fields="fields"
      tbody-tr-class="access-list-row"
      hover
      class="border-bottom fs-14"
    >
      <!-- Submital No -->
      <template v-slot:cell(submital_no)="data">
        <p v-if="data.value" class="mb-0">
          <font-awesome-icon v-if="submitalLocked(data.item)" :icon="['fas', 'lock-alt']" fixed-width />
          <span>{{ data.value }}</span>
        </p>
        <span v-else>-</span>
      </template>
      <!-- Title -->
      <template v-slot:cell(title)="data">
        <div v-if="isAuthorized && !submitalLocked(data.item)">
          <b-input
            v-if="editingTitle && data.item.id == selectedSubmital.id"
            v-model="selectedSubmitalForm.title"
            size="sm"
            autofocus
            @blur="updateSubmital"
            @keyup.enter="updateSubmital"
          />
          <div v-else>
            <b-link v-if="data.value" class="edit-link" @click="editSubmital(data.item, 'editingTitle')" @mouseover="hoverSubmital(data.item.id, 'hoveringTitle')" @mouseleave="unhoverSubmital">
              {{ data.value }}<font-awesome-icon v-show="hoveringTitle && data.item.id == hoveredSubmitalId" :icon="['fas', 'edit']" fixed-width class="text-black-50" />
            </b-link>
            <b-link v-else class="font-italic edit-link text-muted" @click="editSubmital(data.item, 'editingTitle')" @mouseover="hoverSubmital(data.item.id, 'hoveringTitle')" @mouseleave="unhoverSubmital">
              (Sin Nombre)<font-awesome-icon v-show="hoveringTitle && data.item.id == hoveredSubmitalId" :icon="['fas', 'edit']" fixed-width class="text-black-50" />
            </b-link>
          </div>
        </div>
        <div v-else>
          <span v-if="data.value">{{ data.value }}</span>
          <span v-else class="font-italic text-muted">(Sin Nombre)</span>
        </div>
      </template>

      <!-- Quantity -->
      <template v-slot:cell(quantity)="data">
        <div v-if="isAuthorized && !submitalLocked(data.item)">
          <div v-if="editingQuantity && data.item.id == selectedSubmital.id">
            <ValidationProvider rules="required|min_value:1" v-slot="{ errors }">
              <b-input
                v-model="selectedSubmitalForm.quantity"
                size="sm"
                autofocus
                style="width: 50px"
                :class="errors.length > 0 ? 'red-input-border' : null"
                v-on="errors.length == 0 ? { blur: () => updateSubmital() } : { blur: () => cancelEditing() }"
              />
            </ValidationProvider>
          </div>
          <b-link v-else class="edit-link" @click="editSubmital(data.item, 'editingQuantity')" @mouseover="hoverSubmital(data.item.id, 'hoveringQuantity')" @mouseleave="unhoverSubmital">
            {{ data.value }}<font-awesome-icon v-show="hoveringQuantity && data.item.id == hoveredSubmitalId" :icon="['fas', 'edit']" fixed-width class="text-black-50" />
          </b-link>
        </div>
        <span v-else>{{ data.value }}</span>
      </template>

      <!-- related_configurable -->
      <template v-slot:cell(related_configurable)="data">
        <span v-if="data.item.related_configurable">{{ data.item.related_configurable.submital_no || data.item.related_configurable.acceso_id }}</span>
        <span v-else>-</span>
      </template>

      <!-- Status -->
      <template v-slot:cell(status)="data">
        <b-row v-if="isAuthorized" align-h="around">
          <div v-if="data.item.progress == 100">
            <font-awesome-icon :icon="['fas', 'check-square']" size="lg" fixed-width class="text-success" />
          </div>
          <b-link v-if="data.item.alarm_data && Object.keys(data.item.alarm_data).length > 0" style="color: inherit" @click="openAlarmsModal(data.item)">
            <font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" fixed-width class="text-danger" />
          </b-link>
          <b-link v-if="data.item.warnings.length > 0" style="color: inherit" @click="openAlarmsModal(data.item)">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" size="lg" fixed-width class="text-warning" />
          </b-link>
        </b-row>
        <div v-else>
          <font-awesome-icon title="No autorizado" :icon="['fas', 'ban']" size="lg" fixed-width class="text-danger" />
        </div>
      </template>

      <!-- Progress -->
      <template v-slot:cell(progress)="data">{{ data.value }}%</template>

      <!-- Actions -->
      <template v-slot:cell(actions)="data">
        <b-row v-if="isAuthorized" align-h="around" align-v="center">
          <Button size="sm" title="Copiar" style="height: 28px" @click="$emit('copy-submital', data.item, true)">
            <font-awesome-icon :icon="['far', 'copy']" size="lg" fixed-width />
          </Button>
          <Button size="sm" variant="blue" @click="goToSubmital(data.item)">
            Config
          </Button>
        </b-row>
      </template>
    </b-table>

    <!-- Alarms Modal -->
    <Modal
      v-if="alarmsModalShow"
      contentWidth="600px"
      :required=true
      @close="alarmsModalShow = false"
    >
      <template #header>
        <p class="fs-20 font-weight-bold ml-1 mb-0" style="line-height: 0.675rem; color: #163D7D;">
          Alarmas y avisos de submital {{ selectedSubmital.submital_no }}
        </p>
      </template>
      <template #body>
      <b-row align-h="center">
        <b-col>
          <b-container v-if="selectedSubmital" class="px-3">
            <div v-for="(stepData, stepName) in selectedSubmital.alarm_data" :key="stepName">
              <b-row v-for="(alarmObj, index) in stepData.alarms" :key="index">
                <p class="text-danger mb-1">
                  {{ Object.values(alarmObj)[0] }}
                </p>
              </b-row>
            </div>
            <b-row v-if="selectedSubmital.warnings.length > 0">
              <p v-for="warning in selectedSubmital.warnings" :key="warning" class="text-warning mb-1">
                <font-awesome-icon :icon="['far', 'ban']" fixed-width />
                {{ warning }}
              </p>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      </template>
      <template #footer>
        <span></span>
      </template>
    </Modal>

    <!-- Alert -->
    <ToastAlert :show="alertShow" :variant="alertVariant" @close="alertShow = false">
      {{ alertMessage }}
    </ToastAlert>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import Button from '../../shared/Button'
import ToastAlert from '../../shared/ToastAlert'
import Modal from '../../shared/Modal'

export default {
  name: 'ProjectShowSubmitalTable',
  components: {
    ValidationProvider,
    Button,
    ToastAlert,
    Modal
  },
  props: {
    submitals: {
      type: Array
    },
    isAuthorized: {
      type: Boolean
    }
  },
  data () {
    return {
      selectedSubmital: null,
      selectedSubmitalForm: {
        title: null,
        quantity: null,
        // width: null,
        // height: null,
        // design_id: null,
        // motor_id: null,
      },
      hoveredSubmitalId: null,
      hoveringTitle: false,
      hoveringQuantity: false,
      // hoveringWidth: false,
      // hoveringHeight: false,
      // hoveringDesign: false,
      // hoveringMotor: false,
      editingTitle: false,
      editingQuantity: false,
      // editingWidth: false,
      // editingHeight: false,
      // editingDesign: false,
      // editingMotor: false,
      alarmsModalShow: false,
      fields: [
        { key: 'submital_no', label: 'ID', thClass: 'top-borderless', thStyle: { width: '120px' } },
        { key: 'title', label: 'Nombre', thClass: 'top-borderless' },
        { key: 'quantity', label: 'Cant.', tdClass: 'text-center', thClass: 'top-borderless text-center' },
        { key: 'related_configurable', label: 'CA', tdClass: 'text-center', thClass: 'top-borderless text-center' },
        // { key: 'width', label: 'Ancho', tdClass: 'text-center', thClass: 'top-borderless text-center' },
        // { key: 'height', label: 'Alto', tdClass: 'text-center', thClass: 'top-borderless text-center' },
        // { key: 'design', label: 'Diseño', thClass: 'top-borderless', thStyle: { width: '250px' } },
        // { key: 'motor', label: 'Motor', thClass: 'top-borderless', thStyle: { width: '200px' } },
        { key: 'status', label: '', tdClass: 'text-center', thClass: 'top-borderless' },
        { key: 'progress', label: 'Progreso', tdClass: 'text-center', thClass: 'top-borderless text-center' },
        { key: 'actions', label: '', thClass: 'top-borderless', thStyle: { width: '120px' } }
      ],
      processing: false,
      alertShow: false,
      alertVariant: null,
      alertMessage: ''
    }
  },
  methods: {
    goToSubmital (submital) {
      this.$router.push(`/app/prod/submitals/${submital.id}`)
    },
    hoverSubmital (submitalId, property) {
      this.hoveredSubmitalId = submitalId
      this[property] = true
    },
    unhoverSubmital () {
      this.hoveredSubmitalId = null
      this.hoveringTitle = false
      this.hoveringQuantity = false
      // this.hoveringWidth = false
      // this.hoveringHeight = false
      // this.hoveringDesign = false
      // this.hoveringMotor = false
    },
    cancelEditing () {
      // console.log('cancel editing')
      this.editingTitle = false
      this.editingQuantity = false
      // this.editingWidth = false
      // this.editingHeight = false
      // this.editingDesign = false
      // this.editingMotor = false
      this.hoveredSubmitalId = null
      this.hoveringTitle = false
      this.hoveringQuantity = false
      // this.hoveringWidth = false
      // this.hoveringHeight = false
      // this.hoveringDesign = false
      // this.hoveringMotor = false
    },
    editSubmital (submital, property) {
      this.selectedSubmital = submital
      this.selectedSubmitalForm.title = this.selectedSubmital.title
      this.selectedSubmitalForm.quantity = this.selectedSubmital.quantity
      // this.selectedSubmitalForm.width = this.selectedSubmital.width
      // this.selectedSubmitalForm.height = this.itemHeight(this.selectedSubmital)
      // this.selectedSubmitalForm.design_id = this.selectedSubmital.design_id
      // this.selectedSubmitalForm.motor_id = this.selectedSubmital.motor_id
      this[property] = true
    },
    updateSubmital () {
      if (this.processing) { return }
      this.processing = true;
      this.$http.patch(`/api/production/submitals/${this.selectedSubmital.id}`, {
          submital: this.selectedSubmitalForm
        })
        .then((res) => {
          this.$emit('submital-updated', res.data)
          this.cancelEditing()
        })
        .catch((e) => {
          console.log(e)
          this.alertVariant = 'danger'
          this.alertMessage = 'No funcionó'
          this.alertShow = true
         })
        .finally(this.processing = false)
    },
    openAlarmsModal (submital) {
      this.selectedSubmital = submital
      this.alarmsModalShow = true
    },
    submitalLocked (submital) {
      return submital.locked_at != null
    }
  }
}
</script>
